export default "__VITE_ASSET__c73d5f57__"